import dynamic from 'next/dynamic';

import { type SessionListHost } from '../session-list/session-list-host';

/**
 * Lazy boundary for the schedule-upload modal, the only name published on `.`.
 * A static re-export would pull the modal's cone into the eager barrel.
 */
export const LazyUploadSessionScheduleModal = dynamic<{ host: SessionListHost }>(
  () =>
    import('./upload-session-schedule-modal').then((mod) => ({
      default: mod.UploadSessionScheduleModal,
    })),
  {
    ssr: false,
    loading: ({ error }) => {
      if (error) throw error;
      return null;
    },
  }
);
